import {
  FETCH_LIVE_WELD_STATUS_SAGA,
  FETCH_LIVE_WELD_STATUS_SUCCESS,
  FETCH_LIVE_WELD_STATUS_FAILURE,
  START_WELD_STATUS_LOADER,
  CHANGE_WELD_NUMBER,
  CHANGE_WELD_NUMBER_WITH_UID,
} from "./types";

export const startWeldStatusLoader = () => ({
  type: START_WELD_STATUS_LOADER,
});

export const fetchData360LiveSlogSaga = (payload) => ({
  type: FETCH_LIVE_WELD_STATUS_SAGA,
  payload: { ...payload },
});

export const fetchData360LiveSlogSuccess = (data) => ({
  type: FETCH_LIVE_WELD_STATUS_SUCCESS,
  payload: data,
});

export const fetchData360LiveSlogFailure = (error) => ({
  type: FETCH_LIVE_WELD_STATUS_FAILURE,
  payload: error,
});

export const changeWeldNumber = (payload) => ({
  type: CHANGE_WELD_NUMBER,
  payload: { ...payload },
});

export const changeWeldNumberWithUid = (payload) => ({
  type: CHANGE_WELD_NUMBER_WITH_UID,
  payload: { ...payload },
});
